module.exports = __webpack_public_path__ + "src/app/assets/images/scalatimes.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/scalatimes.png
// module id = 631
// module chunks = 0